/* eslint-disable no-throw-literal */
<template>
  <div>
    <interview-route-change-modal
      :show-route-change-modal="showRouteChangeModal"
      @leavePage="routerNext()"
      @stayPage="showRouteChangeModal = false"
    />
    <interview-candidate-header
      :interview="interview"
      :candidate="interviewCandidateInfo.candidate"
      :tab="getTabIndex"
      :pageType="'video'"
      @downloadReport="downloadReport"
      :disabledDownload="disabledDownload"
      :downloadButtonLoading="downloadButtonLoading"
    />
    <div class="page-view">
      <b-container>
        <vue-content-loading v-show="loading" :height="59" :speed="1">
          <rect x="0" y="10" rx="4" ry="4" width="100%" height="75" />
        </vue-content-loading>
        <div v-if="!loading">
          <!-- video detail new -->
          <div class="video-detail-new">
              <div class="video-detail-new__left">
                <div class="video-detail-new__overall-rating">
                      <h3 class="video-detail-new__title">
                         {{resource["candidateDetailOverallRating"]}}
                      </h3>
                      <div class="video-detail-new__scores">
                          <div class="video-detail-new__score">
                              <div class="d-flex align-items-center justify-content-center gap-1">
                                  <h4 class="video-detail-new__subtitle">
                                      {{ resource["candidateDetailTeamScore"] }}
                                  </h4>
                                  <i class="icon-info cursor-pointer" width="16" height="16" v-b-tooltip.hover.bottom="{customClass: 'video-detail-new__tooltip'}" :title="resource['teamScoreTooltip']"/>
                              </div>
                              <span v-if="!teamAverageRate" class="video-detail-new__body-text">{{ resource["candidateDetailTeamScoreEmpty"] }}</span>
                              <div v-else class="video-detail-new__score-icon">
                                  <span>{{ teamAverageRate.toFixed(1) }}</span>
                                  <img :src="getRateIconSvg(teamAverageRate)" width="24" height="24"/>
                              </div>
                          </div>
                          <div class="video-detail-new__score">
                              <div class="d-flex align-items-center justify-content-center gap-1">
                                  <i class="icon-awesome-two" width="16" height="16" />
                                  <h4 class="video-detail-new__subtitle">
                                      {{ resource["candidateDetailAiScore"] }}
                                  </h4>
                                  <i class="icon-info cursor-pointer" width="16" height="16" v-b-tooltip.hover.bottom="{customClass: 'video-detail-new__tooltip'}" :title="resource['aiScoreTooltip']"/>
                              </div>
                              <span v-if="!aiAnalyzeAverageRate" class="video-detail-new__body-text">{{ resource["candidateDetailAiScoreEmpty"] }}</span>
                              <div v-else class="video-detail-new__score-icon">
                                  <span>{{ aiAnalyzeAverageRate.toFixed(1) }}</span>
                                  <img :src="getRateIconSvg(aiAnalyzeAverageRate)" width="24" height="24"/>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="video-detail-new__content">
                    <div class="sub-nav">
                      <b-nav>
                        <b-nav-item
                          id="tab-hrcheckup-1"
                          class="nav-item black d-flex align-items-center"
                          :active="tabIndex === 0"
                          @click="changeTab(0)"
                        >
                          <i class="icon-awesome-two" width="16" height="16" />
                          {{ resource["candidateDetailAnalysisTabTitle"] }}
                          <i v-if="analyzeStatus === 3 && tabIndex !== 0" class="icon-tick-rounded ml-1" width="16" height="16" style="color: #49CA77;" />
                        </b-nav-item>
                        <b-nav-item
                          id="tab-hrcheckup-2"
                          class="nav-item black d-flex align-items-center"
                          :active="tabIndex === 1"
                          @click="changeTab(1)"
                        >
                          <i class="icon-awesome-two" width="16" height="16" />
                          {{ resource["candidateDetailSummaryTabTitle"] }}
                          <i v-if="summaryStatus === 3 && tabIndex !== 1" class="icon-tick-rounded ml-1" width="16" height="16" style="color: #49CA77;" />
                        </b-nav-item>
                        <b-nav-item
                          id="tab-hrcheckup-2"
                          class="nav-item black d-flex align-items-center"
                          :active="tabIndex === 2"
                          @click="changeTab(2)"
                        >
                          {{ resource["candidateDetailTeamNoteTabTitle"] }}
                        </b-nav-item>
                      </b-nav>
                    </div>
                    <LanguageDropdown
                      v-if="checkRemainingRight(4) && tabIndex !== 2 && analyzeStatus === 3"
                      :selected-language="analyzeSelectedLanguage"
                      @setLanguage="setLanguage"
                      variant="yellow"
                    />
                    <div v-if="tabIndex === 0" class="video-detail-new__tab-content">
                      <div class="video-detail-new__status" v-if="analyzeStatus === 4 || analyzeStatus === 100">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="icon left">
                            <path
                              id="Vector"
                              d="M9.99945 4.5781L16.2745 15.4198H3.72445L9.99945 4.5781ZM2.28278 14.5864C1.64112 15.6948 2.44112 17.0864 3.72445 17.0864H16.2745C17.5578 17.0864 18.3578 15.6948 17.7161 14.5864L11.4411 3.74476C10.7994 2.63643 9.19945 2.63643 8.55778 3.74476L2.28278 14.5864ZM9.16612 8.7531V10.4198C9.16612 10.8781 9.54112 11.2531 9.99945 11.2531C10.4578 11.2531 10.8328 10.8781 10.8328 10.4198V8.7531C10.8328 8.29476 10.4578 7.91976 9.99945 7.91976C9.54112 7.91976 9.16612 8.29476 9.16612 8.7531ZM9.16612 12.9198H10.8328V14.5864H9.16612V12.9198Z"
                              fill="#631212"
                            />
                          </g>
                        </svg>
                        {{ resource[ "aiErrorMessage."+ analyzeReasonTypeText]}}
                      </div>
                      <div
                        class="video-detail-new__tab-content-empty video-detail-new__tab-content-empty--with-bg"
                        v-if="analyzeStatus === undefined || analyzeStatus === null || analyzeStatus === 4 || analyzeStatus === 100"
                      >
                        <img
                            src="/images/analysis-icon.svg"
                            loading="lazy"
                            alt="analysis"
                          />
                          <div class="d-flex flex-column align-items-center">
                            <h4 class="video-detail-new__body-title">
                              {{ resource["candidateOverallNotIncludeAnalysisTitle"] }}
                            </h4>
                            <span>{{
                              resource["candidateOverallNotIncludeAnalysisDesc"]
                            }}</span>
                          </div>
                          <button
                            v-if="analyzeButtonLoading"
                            class="video-detail-new__button mt-2"
                            :disabled="analyzeButtonLoading"
                          >
                            <i class="icon-spinner icon-spin" width="14" height="14" />
                            {{
                              resource["candidateOverallNotIncludeAnalysisBtnCreate"]
                            }}
                          </button>
                          <button
                            v-else
                            class="video-detail-new__button mt-2"
                            @click="
                              checkRemainingRight(4) ? analyzeModalHandler() : upgradePlan('analysis')
                            "
                          >
                            <i
                              class="icon-star star-icon"
                              v-if="!checkRemainingRight(4)"
                            ></i>
                            {{
                              checkRemainingRight(4)
                                ? resource[
                                    "candidateOverallNotIncludeAnalysisBtnCreate"
                                  ]
                                : resource["upgradePlanText"]
                            }}
                          </button>
                      </div>
                      <div v-if="analyzeStatus === 1 || analyzeStatus === 2" class="video-detail-new__tab-content-empty">
                        <div
                          class="video-detail-new__action"
                        >
                          <!-- <img src="/images/analysis-icon.svg" loading="lazy" alt="analysis"> -->
                          <div class="loader-gif"></div>
                          <div class="d-flex flex-column align-items-center">
                            <h4 class="video-detail-new__body-title">
                              {{
                                resource[
                                  "candidateOverallNotIncludeAnalyzeLoadingTitle"
                                ]
                              }}
                            </h4>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="analyzeStatus === 3"
                      >
                        <div
                          class="video-detail-new__all-notes"
                          ref="content-1"
                          @scroll="handleScroll"
                        >
                          <div
                            class="video-detail-new__note-item"
                            v-for="(item, index) in interviewCandidateInfo.analyzeResult.analyzes"
                            :key="index"
                          >
                            <div class="video-detail-new__header">
                              <h4 class="video-detail-new__body-title my-2">
                                {{ `${item.criteria}` }}
                              </h4>
                              <div v-if="item.rate" class="video-detail-new__score-icon" :id="'rating-' + item.interviewQuestionId">
                                  <span>{{ item.rate.toFixed(1) }}</span>
                                  <img :src="getRateIconSvg(item.rate)" width="16" height="16"/>
                              </div>
                            </div>
                            <span class="video-detail-new__text" v-html="item.result">
                            </span>
                          </div>
                          <div class="video-detail-new__transcript-rate">
                            {{ resource["candidateAnswerAnalyzeLikeText"] }}
                            <div class="video-detail-new__arrows">
                              <button
                                :class="[
                                  'arrow-btn',
                                  {
                                    active:
                                      interviewCandidateInfo.analyzeResult?.isLiked === true,
                                  },
                                ]"
                                @click="likeButtonLoading ? {} : setLiked(true, 1)"
                              >
                                <i
                                  v-if="likeButtonLoading"
                                  class="icon-spinner icon-spin arrow-icon"
                                  width="14"
                                  height="14"
                                />
                                <i v-else class="icon-like arrow-icon"></i>
                              </button>
                              <button
                                :class="[
                                  'arrow-btn',
                                  {
                                    active:
                                      interviewCandidateInfo.analyzeResult?.isLiked === false,
                                  },
                                ]"
                                @click="likeButtonLoading ? {} : setLiked(false, 1)"
                              >
                                <i
                                  v-if="likeButtonLoading"
                                  class="icon-spinner icon-spin arrow-icon"
                                  width="14"
                                  height="14"
                                />
                                <i v-else class="icon-unlike arrow-icon"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="tabIndex === 1" class="video-detail-new__tab-content">
                      <div class="video-detail-new__status" v-if="summaryStatus === 4 || summaryStatus === 100">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="icon left">
                            <path
                              id="Vector"
                              d="M9.99945 4.5781L16.2745 15.4198H3.72445L9.99945 4.5781ZM2.28278 14.5864C1.64112 15.6948 2.44112 17.0864 3.72445 17.0864H16.2745C17.5578 17.0864 18.3578 15.6948 17.7161 14.5864L11.4411 3.74476C10.7994 2.63643 9.19945 2.63643 8.55778 3.74476L2.28278 14.5864ZM9.16612 8.7531V10.4198C9.16612 10.8781 9.54112 11.2531 9.99945 11.2531C10.4578 11.2531 10.8328 10.8781 10.8328 10.4198V8.7531C10.8328 8.29476 10.4578 7.91976 9.99945 7.91976C9.54112 7.91976 9.16612 8.29476 9.16612 8.7531ZM9.16612 12.9198H10.8328V14.5864H9.16612V12.9198Z"
                              fill="#631212"
                            />
                          </g>
                        </svg>
                        {{ resource[ "aiErrorMessage."+ summaryReasonTypeText]}}
                      </div>
                      <div
                        class="video-detail-new__tab-content-empty video-detail-new__tab-content-empty--with-bg-summary"
                        v-if="summaryStatus === undefined || summaryStatus === null || summaryStatus === 4 || summaryStatus === 100"
                      >
                        <img
                          src="/images/summary-icon.svg"
                          loading="lazy"
                          alt="summary"
                        />
                        <div class="d-flex flex-column align-items-center">
                          <h4 class="video-detail-new__body-title">
                            {{ resource["candidateOverallNotIncludeSummaryTitle"] }}
                          </h4>
                          <span>{{
                            resource["candidateOverallNotIncludeSummaryDesc"]
                          }}</span>
                        </div>
                        <button
                          v-if="analyzeButtonLoading"
                          class="video-detail-new__button mt-2"
                          :disabled="analyzeButtonLoading"
                        >
                          <i class="icon-spinner icon-spin" width="14" height="14" />
                          {{ resource["candidateOverallNotIncludeSummaryBtnCreate"] }}
                        </button>
                        <button
                          v-else
                          class="video-detail-new__button mt-2"
                          @click="
                            checkRemainingRight(4) ? analyzeModalHandler() : upgradePlan('summary')
                          "
                        >
                          <i
                            class="icon-star star-icon"
                            v-if="!checkRemainingRight(4)"
                          ></i>
                          {{
                            checkRemainingRight(4)
                              ? resource["candidateOverallNotIncludeSummaryBtnCreate"]
                              : resource["upgradePlanText"]
                          }}
                        </button>
                      </div>
                      <div v-if="summaryStatus === 1 || summaryStatus === 2" class="video-detail-new__tab-content-empty">
                        <div
                          class="video-detail-new__action"
                        >
                          <!-- <img src="/images/summary-icon.svg" loading="lazy" alt="analysis"> -->
                          <div class="loader-gif"></div>
                          <div class="d-flex flex-column align-items-center">
                            <h4 class="video-detail-new__body-title">
                              {{
                                resource[
                                  "candidateOverallNotIncludeSummaryLoadingTitle"
                                ]
                              }}
                            </h4>
                          </div>
                        </div>
                      </div>
                      <div
                          v-if="summaryStatus === 3"
                        >
                          <div
                            class="video-detail-new__all-notes"
                            ref="content-2"
                            @scroll="handleScroll"
                          >
                            <span class="video-detail-new__text" v-html="interviewCandidateInfo.summaryResult.summary">
                            </span>
                            <div class="video-detail-new__transcript-rate">
                              {{ resource["candidateAnswerSummaryLikeText"] }}
                              <div class="video-detail-new__arrows">
                                <button
                                  :class="[
                                    'arrow-btn',
                                    {
                                      active:
                                        interviewCandidateInfo.summaryResult?.isLiked === true,
                                    },
                                  ]"
                                  @click="likeButtonLoading ? {} : setLiked(true, 2)"
                                >
                                  <i
                                    v-if="likeButtonLoading"
                                    class="icon-spinner icon-spin arrow-icon"
                                    width="14"
                                    height="14"
                                  />
                                  <i v-else class="icon-like arrow-icon"></i>
                                </button>
                                <button
                                  :class="[
                                    'arrow-btn',
                                    {
                                      active:
                                        interviewCandidateInfo.summaryResult?.isLiked === false,
                                    },
                                  ]"
                                  @click="likeButtonLoading ? {} : setLiked(false, 2)"
                                >
                                  <i
                                    v-if="likeButtonLoading"
                                    class="icon-spinner icon-spin arrow-icon"
                                    width="14"
                                    height="14"
                                  />
                                  <i v-else class="icon-unlike arrow-icon"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                    <div v-if="tabIndex === 2" class="video-detail-new__tab-content">
                      <div
                        class="video-detail-new__all-notes"
                        ref="content-3"
                        @scroll="handleScroll"
                      >
                        <div
                          class="video-detail-new__note-item"
                          v-for="(
                            item, index
                          ) in interviewCandidateInfo.interviewCandidateAnswers"
                          :key="index"
                        >
                          <div class="video-detail-new__header">
                            <h4 class="video-detail-new__body-title">
                              <span>{{ `${item.order}/${interviewCandidateInfo.interviewCandidateAnswers.length}` }}</span>{{ `${item.questionTitle}` }}
                            </h4>
                            <div v-if="item.rate" class="video-detail-new__score-icon" :id="'rating-' + item.interviewQuestionId">
                                <span>{{ item.rate.toFixed(1) }}</span>
                                <img :src="getRateIconSvg(item.rate)" width="16" height="16"/>
                            </div>
                            <span v-else class="video-detail-new__score-empty">{{ resource["candidateDetailTeamScoreEmpty"] }}</span>
                          </div>
                          <span class="video-detail-new__text" v-if="item.note">
                            {{ item.note }}
                          </span>
                          <span
                            class="video-detail-new__text p-1"
                            v-else
                          >
                            {{ resource["candidateEvaluationNoNotes"] }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
              <div class="video-detail-new__right">
                  <div class="video-detail-new__header">
                    <h4 class="video-detail-new__title" v-b-tooltip.hover.bottom="{customClass: 'video-detail-new__tooltip', show: getQuestionTitle?.length > 100}" :title="getQuestionTitle?.length > 100 ? getQuestionTitle : ''">
                      <span>{{ `${currentAnswer.order}/${interviewCandidateInfo.interviewCandidateAnswers.length}` }}</span>{{ `${getQuestionTitle?.length > 100 ? getQuestionTitle?.substring(0, 100) + '...' : getQuestionTitle}` }}
                    </h4>
                    <div class="video-detail-new__arrows">
                      <button
                        :class="'arrow-btn-radius'"
                        :disabled="getButtonDisabled"
                        @click="setAnswerIndex(false)"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path d="M9.99969 4.46844C9.73969 4.20844 9.31969 4.20844 9.05969 4.46844L5.99969 7.52844C5.73969 7.78844 5.73969 8.20844 5.99969 8.46844L9.05969 11.5284C9.31969 11.7884 9.73969 11.7884 9.99969 11.5284C10.2597 11.2684 10.2597 10.8484 9.99969 10.5884L7.41302 7.9951L9.99969 5.40844C10.253 5.14844 10.253 4.72177 9.99969 4.46844Z" fill="#FF8D06"/>
                        </svg>
                      </button>
                      <button
                        :class="'arrow-btn-radius'"
                        :disabled="getNextButtonDisabled"
                        @click="setAnswerIndex(true)"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path d="M5.99969 4.47319C5.73969 4.73319 5.73969 5.15319 5.99969 5.41319L8.58635 7.99985L5.99969 10.5865C5.73969 10.8465 5.73969 11.2665 5.99969 11.5265C6.25969 11.7865 6.67969 11.7865 6.93969 11.5265L9.99969 8.46652C10.2597 8.20652 10.2597 7.78652 9.99969 7.52652L6.93969 4.46652C6.68635 4.21319 6.25969 4.21319 5.99969 4.47319Z" fill="#FF8D06"/>
                        </svg>
                      </button>
                    </div>
                  </div>
                  <div class="video-detail-new__video" @mouseenter="isVideoHovered = true" @mouseleave="isVideoHovered = false">
                    <div v-if="videoLoading" class="video-loading">
                      <i
                        class="icon-spinner icon-spin"
                      />
                    </div>
                    <div class="play-icon" v-if="!videoLoading && isVideoPaused" @click="toggleVideo">
                      <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72" fill="none">
                        <g opacity="0.8" clip-path="url(#clip0_20677_588851)">
                        <path d="M30.0602 20.376C29.225 19.5264 27.209 18.9648 27.209 20.592V51.4008C27.209 53.0568 29.225 52.452 30.0602 51.6168L49.3706 37.5264C50.2058 36.6768 50.2058 35.316 49.3706 34.4664L30.0602 20.376Z" fill="white"/>
                        <path d="M35.9997 0.71875C16.5453 0.71875 0.719727 16.5443 0.719727 35.9987C0.719727 55.4531 16.5453 71.2787 35.9997 71.2787C55.4541 71.2787 71.2797 55.4531 71.2797 35.9987C71.2797 16.5443 55.4541 0.71875 35.9997 0.71875ZM35.9997 69.6947C17.4237 69.6947 2.31093 54.5819 2.31093 35.9987C2.31093 17.4227 17.4237 2.30275 35.9997 2.30275C54.5757 2.30275 69.6885 17.4227 69.6885 35.9987C69.6885 54.5747 54.5757 69.6947 35.9997 69.6947Z" fill="white"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_20677_588851">
                        <rect width="72" height="72" fill="white"/>
                        </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div v-if="!videoLoading && isVideoPaused" class="video-detail-new__interview-counts">
                      <div class="tab-switches" v-if="getCurrentTabSwitchCount"
                        v-b-tooltip.hover.bottom="{
                          customClass:'video-detail-new__tooltip',
                          delay: { show: 300, hide: 100 }
                        }"
                        :title="resource['tabSwitchesTooltip']">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                          <path d="M4.95503 5.02979V8.97312L2.98336 7.00146L4.95503 5.02979ZM2.16086 6.58729C1.93336 6.81479 1.93336 7.18229 2.16086 7.40979L4.83836 10.0873C5.20003 10.4548 5.83003 10.1981 5.83003 9.67896V4.32395C5.83003 3.80479 5.20003 3.54229 4.83253 3.90979L2.16086 6.58729ZM8.16336 4.32395V9.67312C8.16336 10.1923 8.79336 10.4548 9.16086 10.0873L11.8384 7.40979C12.0659 7.18229 12.0659 6.81479 11.8384 6.58729L9.16086 3.90979C8.79336 3.54812 8.16336 3.80479 8.16336 4.32395Z" fill="#631212"/>
                        </svg>
                        {{ resource['tabSwitchCountText'].replace("{count}", getCurrentTabSwitchCount ) }}
                      </div>
                      <div v-if="currentAnswer.order === 1 && getConnectionLostCount" class="connection-lost"
                        v-b-tooltip.hover.bottom="{
                          customClass:'video-detail-new__tooltip',
                          delay: { show: 300, hide: 100 }
                        }"
                        :title="resource['connectionLostTooltip']">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
                          <path d="M11.699 5.60734C12.0257 5.87568 12.504 5.85234 12.8015 5.55484C13.1457 5.21068 13.1223 4.63901 12.7432 4.32984C10.649 2.61484 7.95984 1.97901 5.42234 2.42818L6.93317 3.93901C8.619 3.92151 10.3165 4.47568 11.699 5.60734ZM10.3748 6.67484C9.91984 6.34234 9.424 6.09151 8.90484 5.91651L10.6257 7.63734C10.7657 7.29901 10.684 6.89651 10.3748 6.67484ZM8.13484 9.15984C7.42317 8.79234 6.5715 8.79234 5.854 9.15984C5.50984 9.34068 5.44567 9.81318 5.71984 10.0873L6.57734 10.9448C6.80484 11.1723 7.17234 11.1723 7.39984 10.9448L8.25734 10.0873C8.54317 9.81318 8.48484 9.34068 8.13484 9.15984ZM11.4773 10.134L2.40067 1.05734C2.17317 0.829844 1.80567 0.829844 1.57817 1.05734C1.35067 1.28484 1.35067 1.65234 1.57817 1.87984L2.94317 3.25068C2.354 3.54234 1.78234 3.89818 1.25734 4.32984C0.878169 4.63901 0.854835 5.21068 1.199 5.55484C1.4965 5.85234 1.969 5.88151 2.28984 5.61318C2.87317 5.13484 3.51484 4.76151 4.18567 4.48734L5.4865 5.78818C4.82734 5.96318 4.19734 6.25484 3.62567 6.66901C3.22317 6.96068 3.19984 7.54984 3.54984 7.89984L3.55567 7.90568C3.8415 8.19151 4.29067 8.22068 4.62317 7.98151C5.31734 7.49151 6.12817 7.24651 6.939 7.22901L10.6548 10.9448C10.8823 11.1723 11.2498 11.1723 11.4773 10.9448C11.7048 10.729 11.7048 10.3615 11.4773 10.134Z" fill="#631212"/>
                        </svg>
                        {{ resource['connectionLostCountText'].replace("{count}", getConnectionLostCount ) }}
                      </div>
                    </div>
                    <div v-if="!videoLoading && isVideoPaused" class="video-detail-new__video-controls">
                      <button class="step-btn" @click="getButtonDisabled ? null : setAnswerIndex(false)"  :disabled="getButtonDisabled" :style="getButtonDisabled ? 'visibility: hidden' : ''" >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path d="M12.5273 7.33641H5.08066L8.334 4.08307C8.594 3.82307 8.594 3.39641 8.334 3.13641C8.074 2.87641 7.654 2.87641 7.394 3.13641L3.00066 7.52974C2.74066 7.78974 2.74066 8.20974 3.00066 8.46974L7.394 12.8631C7.654 13.1231 8.074 13.1231 8.334 12.8631C8.594 12.6031 8.594 12.1831 8.334 11.9231L5.08066 8.66974H12.5273C12.894 8.66974 13.194 8.36974 13.194 8.00307C13.194 7.63641 12.894 7.33641 12.5273 7.33641Z" fill="white"/>
                        </svg>
                        <span>{{resource["candidateDetailVideoPrevious"]}}</span>
                      </button>
                      <button class="step-btn"  @click="getNextButtonDisabled ? null : setAnswerIndex(true)" :disabled="getNextButtonDisabled" :style="getNextButtonDisabled ? 'visibility: hidden' : ''">
                        <span>{{resource["candidateDetailVideoNext"]}}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path d="M8.00033 2.66797L7.06033 3.60797L10.7803 7.33464H2.66699V8.66797H10.7803L7.06033 12.3946L8.00033 13.3346L13.3337 8.0013L8.00033 2.66797Z" fill="white"/>
                        </svg>
                      </button>
                    </div>
                    <video
                      height="100%"
                      width="100%"
                      v-if="!videoLoading"
                      :controls="!isVideoPaused"
                      oncontextmenu="return false;"
                      controlsList="nodownload"
                      class="embed-responsive-item"
                      ref="videoPlayer"
                      @click="toggleVideo"
                    >
                      <source :src="currentAnswer.videoPath" type="video/mp4" />
                    </video>
                  </div>
                  <div class="sub-nav">
                    <b-nav>
                      <b-nav-item
                        id="tab-hrcheckup-1"
                        class="nav-item black d-flex align-items-center"
                        :active="tabIndexVideo === 0"
                        @click="changeTabVideo(0)"
                      >
                        {{ resource["candidateDetailEvaluationTabTitle"] }}
                      </b-nav-item>
                      <b-nav-item
                        id="tab-hrcheckup-2"
                        class="nav-item black d-flex align-items-center"
                        :active="tabIndexVideo === 1"
                        @click="changeTabVideo(1)"
                      >
                        {{ resource["candidateDetailTranscriptionTabTitle"] }}
                        <i v-if="transcriptionStatus === 3 && tabIndexVideo !== 1" class="icon-tick-rounded ml-1" width="16" height="16" style="color: #49CA77;" />
                      </b-nav-item>
                    </b-nav>
                  </div>
                  <div v-if="tabIndexVideo === 0" class="video-detail-new__right-tab-content">
                    <div class="video-detail-new__rating">
                      <vue-content-loading
                        v-show="ratingLoading"
                        :height="23"
                        :speed="1"
                      >
                        <rect x="0" y="10" rx="0" ry="0" width="100%" height="23" />
                      </vue-content-loading>
                      <template v-if="!ratingLoading">
                        <div v-for="(item, index) in rateMappings" :key="index" class="video-detail-new__score-icon cursor-pointer" :class="currentAnswer.rate === item.value ? 'active' : ''" :id="index + '-rating-' + currentAnswer.interviewQuestionId" @click="setAnswerRate(item.value)">
                            <span>{{ item.text }}</span>
                            <img :src="item.svgFile" width="16" height="16"/>
                        </div>
                      </template>
                      <!-- <rating-stars
                        v-show="!ratingLoading"
                        :value="currentAnswer.rate"
                        @selected="setAnswerRate"
                      ></rating-stars> -->
                    </div>
                    <div
                      class="video-detail-new__note"
                      ref="containerDiv"
                    >
                      <h4 class="video-detail__subtitle">
                        {{ resource["hrvenue.candidateNotes"] }}
                      </h4>

                      <b-form-textarea
                        id="noteTextArea"
                        v-model="currentAnswer.note"
                        :placeholder="resource['hrvenue.candidateNotesPlaceholder']"
                        rows="5"
                        maxlength="3000"
                        @keypress="
                          maxLengthCheck($event, 2000, 'interviewCandidateNote')
                        "
                        @keyup="
                          maxLengthCheck($event, 2000, 'interviewCandidateNote')
                        "
                        no-resize
                      ></b-form-textarea>
                      <div class="d-flex justify-content-end w-100" v-b-tooltip.hover>
                        <button
                          class="video-detail-new__button"
                          :disabled="noteLoading"
                          @click="setAnswerNote(true)"
                        >
                          <i
                            v-if="noteLoading"
                            class="icon-spinner icon-spin"
                            width="14"
                            height="14"
                          />
                          {{ resource["hrvenue.candidateSave"] }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <template v-if="tabIndexVideo === 1">
                    <div class="blue-info" v-if="showInfo && transcriptionStatus === 3 && !searchText.length">
                      <i class="icon-info"></i>
                      <span>{{ resource["candidateAnswerTranscriptInfoMessage"] }}</span>
                      <i class="icon-close cursor-pointer mr-1" @click="showInfo = false"></i>
                    </div>
                    <div
                      class="search-area"
                      v-if="transcriptionStatus === 3"
                    >
                      <img
                        :src="require(`@/assets/hrVenue/search.svg`)"
                        alt="Search Candidate"
                        class="search-area__icon"
                      />
                      <b-form-input
                        id="search-candidates"
                        name="search-candidates"
                        class="search-area__input"
                        v-model="searchText"
                        @input="searchQuestions"
                        :placeholder="resource['candidates.searchPlaceholder']"
                      />
                    </div>
                  </template>
                  <div
                    v-if="tabIndexVideo === 1"
                    class="video-detail-new__right-tab-content"
                    ref="content-4"
                    @scroll="handleScroll"
                  >
                    <div class="video-detail-new__status" v-if="transcriptionStatus === 4 || transcriptionStatus === 100">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="icon left">
                          <path
                            id="Vector"
                            d="M9.99945 4.5781L16.2745 15.4198H3.72445L9.99945 4.5781ZM2.28278 14.5864C1.64112 15.6948 2.44112 17.0864 3.72445 17.0864H16.2745C17.5578 17.0864 18.3578 15.6948 17.7161 14.5864L11.4411 3.74476C10.7994 2.63643 9.19945 2.63643 8.55778 3.74476L2.28278 14.5864ZM9.16612 8.7531V10.4198C9.16612 10.8781 9.54112 11.2531 9.99945 11.2531C10.4578 11.2531 10.8328 10.8781 10.8328 10.4198V8.7531C10.8328 8.29476 10.4578 7.91976 9.99945 7.91976C9.54112 7.91976 9.16612 8.29476 9.16612 8.7531ZM9.16612 12.9198H10.8328V14.5864H9.16612V12.9198Z"
                            fill="#631212"
                          />
                        </g>
                      </svg>
                      {{ resource[ "aiErrorMessage."+ transcriptionReasonTypeText] }}
                    </div>
                    <div v-if="transcriptionStatus === 1 || transcriptionStatus === 2" class="video-detail-new__right-tab-content-empty">
                      <div
                        class="video-detail-new__action"
                      >
                        <!-- <img src="/images/transcribe-icon.svg" loading="lazy" alt="transcribe"> -->
                        <div class="loader-gif"></div>
                        <div class="d-flex flex-column align-items-center">
                          <h4 class="video-detail__subtitle">
                            {{
                              resource[
                                "candidateOverallNotIncludeTranscribeLoadingTitle"
                              ]
                            }}
                          </h4>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="transcriptionStatus === undefined || transcriptionStatus === null || transcriptionStatus === 4 || transcriptionStatus === 100"
                      class="video-detail-new__right-tab-content-empty video-detail-new__right-tab-content-empty--with-bg"
                    >
                      <div
                        class="video-detail-new__action"
                      >
                        <img
                          src="/images/transcribe-icon.svg"
                          loading="lazy"
                          alt="transcribe"
                        />
                        <div class="d-flex flex-column align-items-center">
                          <h4 class="video-detail__subtitle">
                            {{
                              resource["candidateOverallNotIncludeTranscribeTitle"]
                            }}
                          </h4>
                          <span>{{
                            resource["candidateOverallNotIncludeTranscribeDesc"]
                          }}</span>
                        </div>
                        <button
                          v-if="analyzeButtonLoading"
                          class="video-detail-new__button mt-2"
                          :disabled="analyzeButtonLoading"
                        >
                          <i class="icon-spinner icon-spin" width="14" height="14" />
                          {{
                            resource["candidateOverallNotIncludeTranscribeBtnCreate"]
                          }}
                        </button>
                        <button
                          v-else
                          class="video-detail-new__button mt-2"
                          @click="
                            checkRemainingRight(3) ? startAnalyze(1) : upgradePlan('transcription')
                          "
                        >
                          <i
                            class="icon-star star-icon"
                            v-if="!checkRemainingRight(3)"
                          ></i>
                          {{
                            checkRemainingRight(3)
                              ? resource[
                                  "candidateOverallNotIncludeTranscribeBtnCreate"
                                ]
                              : resource["upgradePlanText"]
                          }}
                        </button>
                      </div>
                    </div>
                    <template
                      v-if="transcriptionStatus === 3"
                    >
                      <div
                        v-if="searchText.length > 2 && filteredQuestionList"
                        class="video-detail-new__summary"
                      >
                        <div
                          v-if="filteredQuestionList.length < 1 && !searchLoading"
                          class="d-flex text-center justify-content-center h-100 flex-column"
                        >
                          <img
                            :src="require('@/assets/hrVenue/search-big.svg')"
                            alt="icon search"
                            height="45"
                          />
                          <p>{{ resource["label.NoResult"] }}</p>
                        </div>
                        <div v-else>
                          <vue-content-loading
                            v-if="searchLoading"
                            :height="150"
                            :speed="1"
                          >
                            <rect
                              x="0"
                              y="0"
                              rx="4"
                              ry="4"
                              width="100%"
                              height="150"
                            />
                          </vue-content-loading>
                          <span v-for="(item, index) in filteredQuestionList" :key="index" v-html="item.text" class="video-detail-new__text"></span>
                        </div>
                      </div>
                      <div
                        v-else-if="formattedText"
                        class="video-detail-new__summary"
                      >
                        <div>
                          <span v-for="(word, index) in formattedText" :key="index">
                            <b-tooltip
                              :target="'tryInfo' + index"
                              placement="topright"
                              class="video-detail__second-tooltip"
                              variant="light"
                              boundary="viewport"
                            >
                              {{ formatTime(word.start) }}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <path
                                  d="M4.61914 4.54669V11.4534C4.61914 11.98 5.19914 12.3 5.64581 12.0134L11.0725 8.56003C11.4858 8.30003 11.4858 7.70003 11.0725 7.43336L5.64581 3.98669C5.19914 3.70003 4.61914 4.02003 4.61914 4.54669Z"
                                  fill="#FF8D06"
                                />
                              </svg>
                            </b-tooltip>
                            <span
                              :id="'tryInfo' + index"
                              @click="seekTo(word.start)"
                              class="video-detail-new__text video-detail-new__text--second"
                            >
                              {{ word.word }}
                            </span>
                          </span>
                        </div>
                        <div class="video-detail-new__transcript-rate" v-if="transcriptionStatus === 3 && !searchText.length">
                          {{ resource["candidateAnswerTranscriptRateText"] }}
                          <div class="video-detail-new__arrows">
                            <button
                              :class="[
                                'arrow-btn',
                                {
                                  active: interviewCandidateInfo.transcriptionResult.isLiked === true,
                                },
                              ]"
                              @click="likeButtonLoading ? {} : setLiked(true, 3)"
                            >
                              <i
                                v-if="likeButtonLoading"
                                class="icon-spinner icon-spin arrow-icon"
                                width="14"
                                height="14"
                              />
                              <i v-else class="icon-like arrow-icon"></i>
                            </button>
                            <button
                              :class="[
                                'arrow-btn',
                                {
                                  active: interviewCandidateInfo.transcriptionResult.isLiked === false,
                                },
                              ]"
                              @click="likeButtonLoading ? {} : setLiked(false, 3)"
                            >
                              <i
                                v-if="likeButtonLoading"
                                class="icon-spinner icon-spin arrow-icon"
                                width="14"
                                height="14"
                              />
                              <i v-else class="icon-unlike arrow-icon"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div v-else class="video-detail-new__summary">
                        <div>
                          <span>
                            {{ currentAnswer.text }}
                          </span>
                        </div>
                        <div class="video-detail-new__transcript-rate" v-if="transcriptionStatus === 3 && !searchText.length">
                          {{ resource["candidateAnswerTranscriptRateText"] }}
                          <div class="video-detail-new__arrows">
                            <button
                              :class="[
                                'arrow-btn',
                                {
                                  active: interviewCandidateInfo.transcriptionResult.isLiked === true,
                                },
                              ]"
                              @click="likeButtonLoading ? {} : setLiked(true, 3)"
                            >
                              <i
                                v-if="likeButtonLoading"
                                class="icon-spinner icon-spin arrow-icon"
                                width="14"
                                height="14"
                              />
                              <i v-else class="icon-like arrow-icon"></i>
                            </button>
                            <button
                              :class="[
                                'arrow-btn',
                                {
                                  active: interviewCandidateInfo.transcriptionResult.isLiked === false,
                                },
                              ]"
                              @click="likeButtonLoading ? {} : setLiked(false, 3)"
                            >
                              <i
                                v-if="likeButtonLoading"
                                class="icon-spinner icon-spin arrow-icon"
                                width="14"
                                height="14"
                              />
                              <i v-else class="icon-unlike arrow-icon"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
              </div>
          </div>
          <!-- video detail new end-->
        </div>
      </b-container>
    </div>
    <b-modal v-model="feedbackModal" id="modal-center" centered hide-footer modal-class="new-modal" @hide="hideFeedbackModal">
      <div slot="modal-header" class="d-flex justify-content-end w-100">
        <i class="icon-close custom-modal-close cursor-pointer" @click="hideFeedbackModal" />
      </div>
      <div class="d-flex align-items-center justify-content-center flex-column w-100 feedback-form">
        <img src="/images/feedback.svg" loading="lazy" alt="feedback">
        <h2>{{resource["feedbackPopupTitle"]}} </h2>
        <p>{{resource["feedbackPopupDescription"]}}</p>
        <validation-observer ref="feedbackForm" class="mb-2 w-100">
          <validate-form
            id="feedbackFormTextArea"
            :name="'Feedback'"
            :placeholder="resource['feedbackPopupPlaceholder']"
            v-model="feedbackText"
            which-component="b-form-textarea"
            rows="6"
            max-rows="6"
            maxlength="300"
            class-group="m-0 p-0 col-12"
            rules="required|min:5|max:300"
            @keypress="
              maxLengthCheck($event, 300, 'feedbackText')
            "
            @keyup="
              maxLengthCheck($event, 300, 'feedbackText')
            "
            no-resize
          />
        </validation-observer>
        <div class="d-flex justify-content-end w-100 mb-3">
          <span class="feedback-length">{{ feedbackText.length || 0 }}/300</span>
        </div>
        <div class="w-100 d-flex justify-content-between gap-3">
          <b-button
            name="cancel"
            class="border-button"
            @click="hideFeedbackModal"
          >
            {{ resource["feedbackPopupCancel"] }}
          </b-button>
          <b-button
            name="upgrade"
            class="bg-button gap-2 d-flex align-items-center"
            @click="feedbackModalSubmit()"
          >
          {{resource["feedbackPopupSubmit"]}}
          </b-button>
        </div>
      </div>
    </b-modal>
    <analyze-modal
        :showModal="showAnalyzeModal"
        pageType="interview-detail"
        :analyzeOneCandidate="true"
        :rights="rights"
        :interviewId="interviewCandidateInfo?.interviewCandidateLog?.interviewId"
        :selectedCandidates="[{id: interviewCandidateLogId}]"
        @closeModalHandler="closeAnalyzeModalHandler"
      />
  </div>
</template>

<script>
import HrVenueService from '@/services/hrvenue.service';
import { showNotification } from '@/static/helpers';
import ResourceManager from '@/services/resource.service';
import AnalyzeModal from '@/components/common/AnalyzeModal.vue';
import { languageItems } from '@/static/languageItems';
import signalRService from '../../../composables/signalrService';
import LanguageDropdown from '../languageDropdown.vue';

export default {
  name: 'InterviewCandidateVideoDetail',

  components: {
    InterviewCandidateHeader: () => import('./interviewCandidateHeader.vue'),
    // interviewCandidateCardItem: () => import('./interviewDetail/interviewCandidateCardItem.vue'),
    InterviewRouteChangeModal: () => import('./interviewCandidateRouteChangeModal.vue'),
    LanguageDropdown,
    AnalyzeModal,
  },

  props: {
    interviewCandidateInfo: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      showRouteChangeModal: false,
      routerNext: null,
      noteLoading: false,
      ratingLoading: false,
      loading: true,
      videoLoading: false,
      interviewCandidate: {},
      candidate: {},
      interviewAnswers: [],
      interviewNote: '',
      answerLink: '',
      answerIndex: 0,

      rights: [],
      interview: {},
      tabIndex: 0,
      tabIndexVideo: 0,
      searchText: '',
      searchTextTimeout: null,
      searchLoading: false,
      filteredQuestionList: [],
      noteChanged: false,
      oldNote: '',
      analyzeButtonLoading: false,
      likeButtonLoading: false,
      downloadButtonLoading: false,
      disabledDownload: true,
      feedbackModal: false,
      feedbackText: '',
      feedbackModalType: 0,
      showInfo: true,
      rateMappings: [],
      isVideoPaused: true,
      isVideoHovered: false,
      aiReasonType: {
        0: 'None',
        1: 'System',
        2: 'InterviewIsNull',
        3: 'InterviewIsPassive',
        4: 'TranscriptIsNull',
        100: 'RightError',
      },
      analyzeSelectedLanguage: null,
      showAnalyzeModal: false,
    };
  },

  params: {
    tab: { type: Number, required: false },
    switch: { type: Boolean, required: false },
  },

  watch: {
    answerIndex() {
      this.$nextTick(() => {
        setTimeout(() => {
          const video = this.$refs.videoPlayer;
          if (video) {
            video.removeEventListener('play', this.onVideoPlay);
            video.removeEventListener('pause', this.onVideoPause);
            video.addEventListener('play', this.onVideoPlay);
            video.addEventListener('pause', this.onVideoPause);
          }
        }, 600);
      });
    },
  },

  computed: {
    interviewCandidateLogId() {
      return this.$route.params.interviewCandidateLogId;
    },
    transcriptionStatus() {
      return this.interviewCandidateInfo.transcriptionResult?.status;
    },
    transcriptionReasonType() {
      return this.interviewCandidateInfo.transcriptionResult?.reasonType;
    },
    transcriptionReasonTypeText() {
      return this.aiReasonType[this.transcriptionResult?.reasonType] || 'System';
    },
    analyzeStatus() {
      return this.interviewCandidateInfo.analyzeResult?.status;
    },
    analyzeReasonType() {
      return this.interviewCandidateInfo.analyzeResult?.reasonType;
    },
    analyzeReasonTypeText() {
      return this.aiReasonType[this.interviewCandidateInfo.analyzeResult?.reasonType] || 'System';
    },
    summaryStatus() {
      return this.interviewCandidateInfo.summaryResult?.status;
    },
    summaryReasonType() {
      return this.interviewCandidateInfo.summaryResult?.reasonType;
    },
    summaryReasonTypeText() {
      return this.aiReasonType[this.interviewCandidateInfo.summaryResult?.reasonType] || 'System';
    },
    aiAnalyzeAverageRate() {
      return this.interviewCandidateInfo.interviewCandidateLog.aiAnalyzeAverageRate;
    },
    teamAverageRate() {
      return this.interviewCandidateInfo.interviewCandidateLog.averageRate;
    },
    currentAnswer() {
      return this.interviewCandidateInfo.interviewCandidateAnswers[
        this.answerIndex
      ];
    },
    showPreviousButton() {
      return this.answerIndex !== 0;
    },
    showNextButton() {
      return (
        this.answerIndex
        !== this.interviewCandidateInfo.interviewCandidateAnswers.length - 1
      );
    },
    getButtonDisabled() {
      if (this.answerIndex !== 0) {
        return false;
      }
      return true;
    },
    getNextButtonDisabled() {
      if (
        this.answerIndex
        !== this.interviewCandidateInfo.interviewCandidateAnswers.length - 1
      ) {
        return false;
      }
      return true;
    },
    getTabIndex() {
      return this.$route.params.tab;
    },
    getQuestionTitle() {
      // return this.currentAnswer.questionTitle.length > 100
      //   ? `${this.currentAnswer.questionTitle.substring(0, 100)}...`
      //   : this.currentAnswer.questionTitle;
      return this.currentAnswer.questionTitle;
    },

    getInterviewCandidateStatusId() {
      return this.interviewCandidateInfo.interviewCandidateLog.interviewCandidateStatusId;
    },

    getInterviewId() {
      return this.interviewCandidateInfo.interviewCandidateLog.interviewId;
    },

    formattedText() {
      const ca = this.currentAnswer;
      const formattedText = ca.wordJson
        ? JSON.parse(ca.wordJson)
        : null;

      return formattedText;
    },

    uit() {
      return this.$route.query.uit;
    },

    getCurrentTabSwitchCount() {
      return this.currentAnswer?.tabSwitchCount || null;
    },
    getConnectionLostCount() {
      return this.interviewCandidateInfo?.interviewCandidateLog?.numberOfRepeatLogins || null;
    },
  },

  async created() {
    try {
      await this.getData();
      this.rights = await this.getRights();
      this.checkDisabledDownload();

      if (
        this.getInterviewCandidateStatusId === 1
        || this.getInterviewCandidateStatusId === 2
      ) {
        showNotification(
          this.resource['Label.Warning'],
          this.resource['candidateDetail.interviewCompletedWarning'],
          'warning',
        );
        const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

        return this.$router.push({
          name: 'InterviewDetailView',
          params: {
            interviewId: this.getInterviewId,
            lang,
          },
        });
      }
    } catch (err) {
      showNotification(
        this.resource['Label.Warning'],
        this.resource['candidateDetail.interviewCannotAccessWarning'],
        'warning',
      );
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

      return this.$router.push({
        name: 'InterviewDetailView',
        params: {
          interviewId: this.getInterviewId,
          lang,
        },
      });
    }
    this.loading = false;
    this.rateMappings = [
      {
        min: 0, max: 1, svgFile: require('@/assets/icon/0-1.svg'), text: this.resource.rateTextOne, value: 1,
      },
      {
        min: 1, max: 2, svgFile: require('@/assets/icon/1-2.svg'), text: this.resource.rateTextTwo, value: 2,
      },
      {
        min: 2, max: 3, svgFile: require('@/assets/icon/2-3.svg'), text: this.resource.rateTextThree, value: 3,
      },
      {
        min: 3, max: 4, svgFile: require('@/assets/icon/3-4.svg'), text: this.resource.rateTextFour, value: 4,
      },
      {
        min: 4, max: 5, svgFile: require('@/assets/icon/4-5.svg'), text: this.resource.rateTextFive, value: 5,
      },
    ];
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.handleScroll();
      }, 100);
    });

    this.$nextTick(() => {
      setTimeout(() => {
        const video = this.$refs.videoPlayer;
        if (video) {
          video.addEventListener('play', this.onVideoPlay);
          video.addEventListener('pause', this.onVideoPause);
        }
      }, 600);
    });

    window.addEventListener('resize', this.handleScroll);

    signalRService.addEventListener('TranscriptionEvent', async (data) => {
      const interviewCandidateLogId = this.interviewCandidateLogId;
      if (data.interviewCandidateLogId !== interviewCandidateLogId) {
        return;
      }

      const transcriptionResult = await HrVenueService.getTranscriptionResult(interviewCandidateLogId);
      this.interviewCandidateInfo.transcriptionResult = transcriptionResult;

      if (transcriptionResult?.status === 3) {
        this.interviewCandidateInfo
          .interviewCandidateAnswers
          .forEach((oldItem) => {
            const newItem = transcriptionResult.transcriptions.find((i) => i.interviewAnswerId === oldItem.interviewAnswerId);
            if (newItem) {
              oldItem.text = newItem?.text;
              oldItem.wordJson = newItem?.wordJson;
            }
          });
      }
    });

    signalRService.addEventListener('AnalyzeEvent', async (data) => {
      const interviewCandidateLogId = this.interviewCandidateLogId;
      if (data.interviewCandidateLogId !== interviewCandidateLogId) {
        return;
      }

      const language = this.analyzeSelectedLanguage;

      const analyzeResult = await HrVenueService.getAnalyzeResult(interviewCandidateLogId, language);
      this.interviewCandidateInfo.analyzeResult = analyzeResult;

      const result = await HrVenueService.getInterviewOfCandidate(this.interviewCandidateLogId, this.uit);
      this.interviewCandidateInfo.interviewCandidateLog.aiAnalyzeAverageRate = result.interviewCandidateLog.aiAnalyzeAverageRate;
    });

    signalRService.addEventListener('SummaryEvent', async (data) => {
      const interviewCandidateLogId = this.interviewCandidateLogId;
      if (data.interviewCandidateLogId !== interviewCandidateLogId) {
        return;
      }

      const language = this.analyzeSelectedLanguage;

      const summaryResult = await HrVenueService.getSummaryResult(interviewCandidateLogId, language);

      this.interviewCandidateInfo.summaryResult = summaryResult;
    });
  },
  updated() {
    this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleScroll);
    signalRService.removeEventListener('TranscriptionEvent');
    signalRService.removeEventListener('AnalyzeEvent');
    signalRService.removeEventListener('SummaryEvent');

    const video = this.$refs.videoPlayer;
    if (video) {
      video.removeEventListener('play', this.onVideoPlay);
      video.removeEventListener('pause', this.onVideoPause);
    }
  },
  methods: {
    analyzeModalHandler() {
      this.showAnalyzeModal = true;
    },
    closeAnalyzeModalHandler() {
      this.showAnalyzeModal = false;
    },
    async setLanguage(language) {
      this.analyzeSelectedLanguage = language.id;
      const analyzeResponse = await HrVenueService.getAnalyzeResult(this.interviewCandidateLogId, language.id);
      const summaryResponse = await HrVenueService.getSummaryResult(this.interviewCandidateLogId, language.id);
      if (analyzeResponse?.status) {
        this.interviewCandidateInfo.analyzeResult = analyzeResponse;
      }
      if (summaryResponse?.status) {
        this.interviewCandidateInfo.summaryResult = summaryResponse;
      }
      if (!analyzeResponse?.status || !summaryResponse?.status) {
        await this.startAnalyze(2);
      }
    },
    toggleVideo() {
      if (this.isVideoPaused) {
        this.$refs.videoPlayer?.play();
        this.isVideoPaused = false;
      } else {
        this.$refs.videoPlayer?.pause();
        this.isVideoPaused = true;
      }
    },
    onVideoPlay() {
      this.isVideoPaused = false;
    },
    onVideoPause() {
      this.isVideoPaused = true;
    },
    getRateIconSvg(rate) {
      const svgFile = this.rateMappings?.find((range) => rate > range.min && rate <= range.max)?.svgFile;

      return svgFile;
    },
    seekTo(time) {
      this.$refs.videoPlayer.currentTime = time;
      this.$refs.videoPlayer.play();
    },

    formatTime(seconds) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = (seconds % 60).toFixed(0);
      return `${minutes}.${
        remainingSeconds < 10 ? '0' : ''
      }${remainingSeconds}`;
    },
    async getRights() {
      const response = await HrVenueService.getRights([3, 4, 9]);
      return response;
    },

    checkRemainingRight(type) {
      const right = this.rights?.find((item) => item.companyRightType === type);
      return right?.totalUsableRight > 0;
    },

    async getData() {
      this.interview = {
        interviewId:
          this.interviewCandidateInfo?.interviewCandidateLog?.interviewId,
        interviewName:
          this.interviewCandidateInfo?.interviewCandidateLog?.interviewName,
        interviewCandidateStatusId:
          this.interviewCandidateInfo?.interviewCandidateLog
            ?.interviewCandidateStatusId,
      };

      this.oldNote = this.interviewCandidateInfo.interviewCandidateAnswers[
        this.answerIndex
      ].note;

      let currentLanguage = null;
      if (typeof ResourceManager.CurrentLang !== 'string') {
        currentLanguage = ResourceManager.CurrentLang.id;
      } else {
        currentLanguage = languageItems.find(
          (item) => item.code === ResourceManager.CurrentLang,
        )?.id;
      }
      this.analyzeSelectedLanguage = this.interviewCandidateInfo?.analyzeResult?.language || currentLanguage;
    },

    async setAnswerNote(openMessage) {
      if (this.currentAnswer.note === this.oldNote) {
        return;
      }
      this.noteLoading = true;

      try {
        const answerResponse = await HrVenueService.setAnswerNote(
          this.interviewCandidateInfo.interviewCandidateLog.id,
          this.currentAnswer.interviewAnswerId,
          this.currentAnswer.interviewQuestionId,
          this.currentAnswer.note,
        );
        if (!answerResponse && openMessage) {
          showNotification(
            this.resource['label.Error'],
            this.resource['candidateDetail.interviewNoteSaveError'],
            'error',
          );

          return;
        }
        if (openMessage) {
          showNotification(
            this.resource['label.Success'],
            this.resource['candidateDetail.interviewNoteSaveSuccess'],
            'success',
          );
        }

        // this.interviewNote = this.interviewCandidate.interviewCandidateNote;

        // dataLayer.push({
        //   event: 'gaEvent',
        //   Category: 'hr-venue',
        //   Action: 'video-mulakat',
        //   Label: 'not-kaydet',
        // });
      } catch (err) {
        showNotification(
          this.resource['label.Error'],
          this.resource['label.Process.Non.Successfully'],
          'error',
        );
      }
      this.$emit('changeNoteStatus', false);
      this.noteLoading = false;
      this.oldNote = this.currentAnswer.note;
    },
    async setAnswerRate(value) {
      const answer = this.currentAnswer;
      try {
        this.ratingLoading = true;

        const answerResponse = await HrVenueService.setAnswerRate(
          this.interviewCandidateInfo.interviewCandidateLog.id,
          answer.interviewAnswerId,
          answer.interviewQuestionId,
          value,
        );

        if (!answerResponse) {
          showNotification(
            this.resource['label.Error'],
            this.resource['label.Process.Non.Successfully'],
            'error',
          );
          return;
        }

        answer.rate = value;
        let averageRate = this.interviewCandidateInfo.interviewCandidateAnswers.filter(
          (item) => item.rate === null,
        ).length > 0
          ? null
          : this.interviewCandidateInfo.interviewCandidateAnswers
            .map((item) => item.rate)
            .reduce((a, b) => a + b, 0)
              / this.interviewCandidateInfo.interviewCandidateAnswers.length;

        const steps = [0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5];
        averageRate = averageRate !== null
          ? steps.reduce((prev, curr) => (Math.abs(curr - averageRate) < Math.abs(prev - averageRate)
            ? curr
            : prev))
          : null;
        this.interviewCandidateInfo.interviewCandidateLog.averageRate = averageRate;

        showNotification(
          this.resource['label.Success'],
          this.resource['candidateDetail.interviewRateSaveSuccess'],
          'success',
        );
      } catch (error) {
        showNotification(
          this.resource['label.Error'],
          this.resource['label.Process.Non.Successfully'],
          'error',
        );
      }

      this.ratingLoading = false;
    },
    async setAnswerIndex(isIncrease) {
      this.videoLoading = true;
      this.setAnswerNote(true);
      const index = isIncrease ? this.answerIndex + 1 : this.answerIndex - 1;
      if (
        isIncrease
        && index
          <= this.interviewCandidateInfo.interviewCandidateAnswers.length - 1
      ) {
        this.answerIndex += 1;
      } else if (!isIncrease && !(index < 0)) {
        this.answerIndex -= 1;
      }
      this.answerLink = this.interviewCandidateInfo.interviewCandidateAnswers[
        this.answerIndex
      ].videoPath;
      this.oldNote = this.interviewCandidateInfo.interviewCandidateAnswers[
        this.answerIndex
      ].note;

      setTimeout(
        (scope) => {
          scope.videoLoading = false;
        },
        500,
        this,
      );
    },

    async setLiked(value, type) {
      this.likeButtonLoading = true;
      let changedValue = null;
      let feedbackNote = null;
      dataLayer.push({
        event: 'ga4_event',
        page_type: 'candidate-evaluation',
        site_type: 'interview',
        event_name: 'button_click',
        event_parameters: {
          button_name: value ? 'thumbs-up' : 'thumbs-down',
          tab_name: type === 1 ? 'detailed-analyses' : 'detailed-summary',
        },
      });
      try {
        if (
          (type === 1
            && value === this.interviewCandidateInfo?.analyzeResult?.isLiked
            && this.feedbackModalType === 0)
          || (type === 2
            && value === this.interviewCandidateInfo?.summaryResult?.isLiked
            && this.feedbackModalType === 0)
          || (type === 3
            && value === this.interviewCandidateInfo?.transcriptionResult?.isLiked
            && this.feedbackModalType === 0)
        ) {
          changedValue = null;
        } else {
          changedValue = value;
        }
        if (this.feedbackText === '') {
          if (type === 1) {
            feedbackNote = this.interviewCandidateInfo?.analyzeResult?.likeNote;
          } else if (type === 2) {
            feedbackNote = this.interviewCandidateInfo?.summaryResult?.likeNote;
          } else if (type === 3) {
            feedbackNote = this.interviewCandidateInfo?.transcriptionResult?.likeNote;
          }
        } else {
          if (type === 1) {
            this.interviewCandidateInfo.analyzeResult.likeNote = this.feedbackText;
          } else if (type === 2) {
            this.interviewCandidateInfo.summaryResult.likeNote = this.feedbackText;
          } else if (type === 3) {
            this.interviewCandidateInfo.transcriptionResult.likeNote = this.feedbackText;
          }
          feedbackNote = this.feedbackText;
        }
        const likedResponse = await HrVenueService.setLiked(
          this.interviewCandidateInfo.interviewCandidateLog.id,
          type,
          changedValue,
          feedbackNote,
        );

        if (!likedResponse) {
          return;
        }

        if (!likedResponse.body?.errorCode) {
          showNotification(
            this.resource['label.Success'],
            this.resource['candidateDetail.interviewRateSaveSuccess'],
            'success',
          );
          type === 1 && (this.interviewCandidateInfo.analyzeResult.isLiked = changedValue);
          type === 2 && (this.interviewCandidateInfo.summaryResult.isLiked = changedValue);
          type === 3 && (this.interviewCandidateInfo.transcriptionResult.isLiked = changedValue);

          if (this.feedbackModalType === 0 && changedValue !== null) {
            this.feedbackModal = true;
            this.feedbackModalType = type;
          } else {
            this.feedbackModal = false;
            this.feedbackModalType = 0;
            this.feedbackText = '';
          }
        }
      } catch (error) {
        showNotification(this.resource['label.Error'], error, 'error');
      }
      this.likeButtonLoading = false;
    },

    async startAnalyze(analyzeWorkOrderType) {
      this.analyzeButtonLoading = true;
      dataLayer.push({
        event: 'ga4_event',
        page_type: 'candidate-evaluation',
        site_type: 'interview',
        event_name: 'button_click',
        event_parameters: {
          tab_name: analyzeWorkOrderType === 1 ? 'transcription' : 'analysis',
          button_name: analyzeWorkOrderType === 1 ? 'transcribe-now' : 'analyze-now',
        },
      });
      try {
        const response = await HrVenueService.startAnalyze(
          analyzeWorkOrderType,
          false,
          this.interviewCandidateInfo.interviewCandidateLog.interviewId,
          [this.interviewCandidateInfo.interviewCandidateLog.id],
          false,
          this.analyzeSelectedLanguage,
        );

        if (!response.body) {
          if (analyzeWorkOrderType === 1) {
            this.interviewCandidateInfo.transcriptionResult.status = 1;

            showNotification(
              this.resource['label.Success'],
              this.resource.candidateDetailTranscriptionStartNotification,
              'success',
            );
          }

          if (analyzeWorkOrderType === 2) {
            this.interviewCandidateInfo.analyzeResult.status = 1;
            this.interviewCandidateInfo.summaryResult.status = 1;

            showNotification(
              this.resource['label.Success'],
              this.resource.candidateDetailAnalyzeAndSummaryStartNotification,
              'success',
            );
          }
        }
      } catch (error) {
        //
      }
      this.analyzeButtonLoading = false;
    },

    upgradePlan(type) {
      dataLayer.push({
        event: 'ga4_event',
        page_type: 'candidate-evaluation',
        site_type: 'interview',
        event_name: 'button_click',
        event_parameters: {
          button_name: 'upgrade-your-plan',
          tab_name: type || 'undefined',
        },
      });
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

      this.$router.push({ name: 'PricingListView', params: { lang } });
    },
    onClickNote() {
      // dataLayer.push({
      //   event: 'gaEvent',
      //   Category: 'hr-venue',
      //   Action: 'video-mulakat',
      //   Label: 'notlar-click',
      // });
    },
    setWhichInput(InpEl, value) {
      if (InpEl === 'interviewCandidateNote') {
        this.interviewCandidate.interviewCandidateNote = value;
      }
      if (InpEl === 'FeedbackText') {
        this.feedbackText = value;
      }
    },
    maxLengthCheck(event, maxLength, inp) {
      const value = event.target.value;
      // this.oldNote !== value ? this.$emit('changeNoteStatus', true) : this.$emit('changeNoteStatus', false);
      if (String(value).length <= maxLength) {
        this.setWhichInput(inp, value);
      } else {
        this.setWhichInput(inp, value.substring(0, maxLength));
        event.stopPropagation();
      }
    },
    checkDisabledDownload() {
      this.disabledDownload = !this.checkRemainingRight(9);
    },

    changeTab(index) {
      this.tabIndex = index;
    },

    changeTabVideo(index) {
      this.tabIndexVideo = index;
    },

    async searchQuestions() {
      clearTimeout(this.searchTextTimeout);
      this.searchTextTimeout = setTimeout(async () => {
        this.removeHighlights();
        if (this.searchText === '') {
          this.searchLoading = true;
          // search api
          this.filteredQuestionList = [];
          this.searchLoading = false;
        } else if (this.searchText.length > 2) {
          this.searchLoading = true;
          // search api
          this.filterQuestionList(this.searchText.toLowerCase().trim());
          this.searchLoading = false;
        }
      }, 500);
    },

    filterQuestionList(query) {
      const filteredQuestionList = [];

      // eslint-disable-next-line no-restricted-syntax
      if (
        this.currentAnswer.questionTitle.toLowerCase().includes(query)
          || this.currentAnswer.text.toLowerCase().includes(query)
      ) {
        const highlightTitle = this.highlightText(this.currentAnswer.questionTitle, query);
        const highlightTranscription = this.highlightText(
          this.currentAnswer.text,
          query,
        );
        filteredQuestionList.push({
          ...this.currentAnswer,
          questionTitle: highlightTitle,
          transcription: highlightTranscription,
        });
      }

      this.filteredQuestionList = filteredQuestionList;
    },

    highlightText(text, query) {
      if (query) {
        const regex = new RegExp(`(${query})`, 'gi');
        return text.replace(
          regex,
          '<span class="highlight" style="background-color: #FFF7DA;">$1</span>',
        );
      }
    },

    removeHighlights() {
      const highlights = this.$el.querySelectorAll('.highlight');
      highlights?.forEach((highlight) => {
        highlight.replaceWith(highlight.textContent);
      });
    },

    setClasses() {
      const contents = Object.keys(this.$refs).filter((key) => key.includes('content'));
      contents.forEach((content) => {
        const el = this.$refs[content];
        const isScrollable = el?.scrollHeight > el?.clientHeight;

        if (!isScrollable) {
          el?.classList.remove('is-bottom-overflowing', 'is-top-overflowing');
          return;
        }

        const isScrolledToBottom = el?.scrollHeight < el?.clientHeight + el?.scrollTop + 1;
        const isScrolledToTop = isScrolledToBottom ? false : el?.scrollTop === 0;
        el?.classList.toggle('is-bottom-overflowing', !isScrolledToBottom);
        el?.classList.toggle('is-top-overflowing', !isScrolledToTop);
      });
    },
    handleScroll() {
      this.setClasses();
    },
    async downloadReport() {
      this.downloadButtonLoading = true;
      if (this.disabledDownload) {
        return;
      }
      try {
        const response = await HrVenueService.getCandidateIndividualReport(
          this.interviewCandidateInfo.interviewCandidateLog.id,
        );
        if (!response.file) {
          return;
        }

        const base64String = `data:application/pdf;base64,${response?.file}`;
        const downloadLink = document.createElement('a');
        downloadLink.href = base64String;
        downloadLink.download = `${response.name}`;
        downloadLink.click();
        this.rights = await this.getRights();
        this.checkDisabledDownload();
      } catch (error) {
        showNotification(this.resource['label.Error'], error.message);
      }
      this.downloadButtonLoading = false;
    },

    feedbackModalSubmit() {
      this.$refs.feedbackForm.validateWithInfo().then((result) => {
        if (result.isValid) {
          if (this.feedbackModalType === 3) {
            const value = this.interviewCandidateInfo.transcriptionResult?.isLiked;
            this.setLiked(value, 3);
          } else {
            const value = this.feedbackModalType === 1 ? this.interviewCandidateInfo.analyzeResult?.isLiked : this.interviewCandidateInfo.summaryResult?.isLiked;
            this.setLiked(value, this.feedbackModalType);
          }
        }
      });
    },

    hideFeedbackModal() {
      this.feedbackModal = false;
      this.feedbackModalType = 0;
      this.feedbackText = '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/style/starter.scss";

.page-view {
  padding: 0 !important;
  background: #FAFAFA !important;
  .container {
    width: 100%;
    max-width: 100% !important;
    padding: 16px;
  }
}

.video-detail-new {
  width: 100%;
  min-height: 812px;
  height: calc(100vh - 90px);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;

  @media screen and (max-width: 1160px) {
    flex-direction: column-reverse;
    gap: 16px;
    height: auto;
  }

  &__left {
    width: 41%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    height: 100%;

    @media screen and (max-width: 1160px) {
      width: 100%;
    }
  }

  &__right {
    width: 58%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 100%;
    gap: 16px;
    border-radius: 8px;
    border: 1px solid #E4E4E4;
    background: #FFF;

    @media screen and (max-width: 1160px) {
      width: 100%;
    }
  }

  &__overall-rating {
    width: 100%;
    display: flex;
    padding: 22px 16px 16px 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 22px;
    align-self: stretch;
    border-radius: 8px;
    border: 1px solid #E4E4E4;
    background: #FFF;
  }

  &__scores {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    align-self: stretch;
  }

  &__score {
    display: flex;
    padding: 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex: 1 0 0;
    border-radius: 8px;
    background: #FAFAFA;

    i {
      color: #333
    }

    .video-detail-new__body-text {
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 8px;
    }
  }

  &__score-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 8px 8px 12px;
    gap: 8px;
    border-radius: 64px;
    border: 0.5px solid #D4D4D4;
    background: #FAFAFA;

    span {
        color: #333;
        font-feature-settings: 'liga' off, 'clig' off;
        font-family: Roboto;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
  }

  &__score-empty {
    color: #878787;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    min-width: 70px;
  }

  &__subtitle {
    width: 100%;
    color: #333;
    text-align: center;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
  }

  &__body-title {
    color: #333;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;

    span {
      font-weight: 400;
      padding-right: 8px;
      border-right: 1px solid #E4E4E4;
      margin-right: 8px;
    }
  }

  &__body-text {
    width: 100%;
    color: #878787;
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  &__content {
    width: 100%;
    display: flex;
    padding: 22px 0 16px 0;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    align-self: stretch;
    border-radius: 8px;
    border: 1px solid #E4E4E4;
    background: #FFF;
    flex:1;
  }

  &__title {
    width: 100%;
    color: #333;
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;

    span {
      font-weight: 400;
      padding-right: 8px;
      border-right: 1px solid #E4E4E4;
      margin-right: 8px;
    }
  }

  &__right-tab-content {
    margin:0 auto;
    overflow-y: auto;
    position: relative;
    width: 100%;
    margin-bottom: 16px;
    min-height: 178px;
    height: 100%;

    -webkit-mask-image: linear-gradient(
      to bottom,
      transparent 0,
      black var(--top-mask-size, 0),
      black calc(100% - var(--bottom-mask-size, 0)),
      transparent 100%
    );
    mask-image: linear-gradient(
      to bottom,
      transparent 0,
      black var(--top-mask-size, 0),
      black calc(100% - var(--bottom-mask-size, 0)),
      transparent 100%
    );
    --top-mask-size: 0px;
    --bottom-mask-size: 0px;

    &:has(.video-detail-new__rating) {
      min-height: 298px;
      height: 100%;
    }

    &:has(.video-detail-new__rating) {
      -webkit-mask-image: none;
      mask-image: none;
      display: flex;
      flex-direction: column;
    }

    &.is-top-overflowing {
      --top-mask-size: 0 !important;

      .blue-info,
      .video-detail-new__summary {
        margin-right: 9px;
      }

      .search-area {
        padding-right: 9px;
      }
    }

    &.is-bottom-overflowing {
      --bottom-mask-size: 71px !important;

      .blue-info {
        margin-right: 9px;
      }

      .search-area {
        padding-right: 9px;
      }
    }

    &::-webkit-scrollbar {
      width: 7px !important;
    }

    &::-webkit-scrollbar-track {
      background-color: #fff !important;
      border-radius: 2px !important;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 2px !important;
      background: linear-gradient(to right, #D8D8D8 3px, #FFF 4px) !important;
    }
  }

  &__right-tab-content-empty {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 8px;

    &--with-bg {
      background: url('~@/assets/empty-transcription.png') no-repeat center;
      background-size: 100% 100%;
      padding: 0 16px;
    }
  }

  &__tab-content {
    min-height: 508px;
    height: 100%;
    overflow-y: auto;
    position: relative;
    width: 100%;

    -webkit-mask-image: linear-gradient(
      to bottom,
      transparent 0,
      black var(--top-mask-size, 0),
      black calc(100% - var(--bottom-mask-size, 0)),
      transparent 100%
    );
    mask-image: linear-gradient(
      to bottom,
      transparent 0,
      black var(--top-mask-size, 0),
      black calc(100% - var(--bottom-mask-size, 0)),
      transparent 100%
    );
    --top-mask-size: 0px;
    --bottom-mask-size: 0px;

    &.is-top-overflowing {
      --top-mask-size: 0 !important;
    }

    &.is-bottom-overflowing {
      --bottom-mask-size: 71px !important;
    }

  }
  &__tab-content-empty {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 8px;

    &--with-bg {
      background: url('~@/assets/empty-ai-screen.png') no-repeat center;
      background-size: 100% 100%;
      padding: 0 16px;
    }

    &--with-bg-summary {
      background: url('~@/assets/empty-ai-summary.png') no-repeat center;
      background-size: 93% 100%;
      padding: 0 16px;
    }
  }

  &__summary {
    position: relative;
    margin: 0 16px;
    min-height: 178px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media screen and (max-width: 1160px) {
      max-height: 200px;
    }
  }

  &__tooltip {
    opacity: 1 !important;

    &.bs-tooltip-right {
        ::v-deep .arrow {
        &::before {
            border: 0 !important;
            background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="9" viewBox="0 0 17 9" fill="none"><path d="M17 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9Z" fill="%23DBF0F9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9L15.5 9L14.6801 8L9.22701 2.22618C8.83239 1.80835 8.16761 1.80835 7.77299 2.22618L2.31993 8L1.5 9Z" fill="%23B7E1F3"/></svg>');
            width: 17px;
            height: 9px;
        }
        }
    }

    &.bs-tooltip-left {
        ::v-deep .arrow {
        &::before {
            border: 0 !important;
            background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="9" viewBox="0 0 17 9" fill="none"><path d="M17 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9Z" fill="%23DBF0F9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9L15.5 9L14.6801 8L9.22701 2.22618C8.83239 1.80835 8.16761 1.80835 7.77299 2.22618L2.31993 8L1.5 9Z" fill="%23B7E1F3"/></svg>');
            width: 17px;
            height: 9px;
            transform: rotate(180deg);
        }
        }
    }

    &.bs-tooltip-bottom {
        padding: 0 !important;
        top: 10px !important;

        ::v-deep .arrow {
        &::before {
            border: 0 !important;
            background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="9" viewBox="0 0 17 9" fill="none"><path d="M17 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9L15.5 9L14.6801 8L9.22701 2.22618C8.83239 1.80835 8.16761 1.80835 7.77299 2.22618L2.31993 8L1.5 9Z" fill="%23E5E5E5"/></svg>') !important;
            width: 17px;
            height: 9px;
            bottom: 5px;
        }
        }
    }

    ::v-deep .tooltip-inner {
        border: 1px solid var(--Stroke-Colors-Light-Blue-Stroke, #E5E5E5) !important;
        background: var(--Background-Colors-Light-Blue, #FFF) !important;
        border-radius: 4px !important;
        padding: 8px 12px !important;
        width: fit-content !important;
        max-width: 300px !important;
        box-shadow: 0px 2px 6px 0px rgba(176, 186, 197, 0.6) !important;

        text-align: left;
        color: var(--Text-Colors-Blue-Text, #333) !important;
        /* Typography/Small Text/1 - Regular */
        font-family: Roboto;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px; /* 150% */
    }
  }

  &__all-notes {
    min-height: 506px;
    height: calc(100vh - 441px);
    overflow: overlay;
    position: relative;
    padding: 0 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 12px;

    -webkit-mask-image: linear-gradient(
      to bottom,
      transparent 0,
      black var(--top-mask-size, 0),
      black calc(100% - var(--bottom-mask-size, 0)),
      transparent 100%
    );
    mask-image: linear-gradient(
      to bottom,
      transparent 0,
      black var(--top-mask-size, 0),
      black calc(100% - var(--bottom-mask-size, 0)),
      transparent 100%
    );
    --top-mask-size: 0px;
    --bottom-mask-size: 0px;

    &.is-top-overflowing {
      --top-mask-size: 0 !important;
      padding-right: 9px !important;
    }

    &.is-bottom-overflowing {
      --bottom-mask-size: 71px !important;
      padding-right: 9px !important;
    }

    &::-webkit-scrollbar {
      width: 7px !important;
    }

    &::-webkit-scrollbar-track {
      background-color: #fff !important;
      border-radius: 2px !important;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 2px !important;
      background: linear-gradient(to right, #D8D8D8 3px, #FFF 4px) !important;
    }

    &:has(.video-detail-new__note-item) {
      justify-content: flex-start;
    }
  }

  &__note-item {
    display: flex;
    padding: 12px 16px 16px 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    align-self: stretch;
    border-radius: 8px;
    background: #FAFAFA;

    .video-detail-new__score-icon {
      padding: 4px 4px 4px 8px;

      span {
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
      }
    }
  }

  &__note {
    margin: 0 16px;
    display: flex;
    flex-direction: column;
    height: 100%;
    ::v-deep textarea {
      padding: 8px !important;
      border: 1px solid #e5e5e5;
      background: #fff;
      font-weight: 400;
      color: #333 !important;
      min-height: 142px;
      box-shadow: none;
      flex:1;

      &::-webkit-scrollbar {
        width: 7px !important;
      }

      &::-webkit-scrollbar-track {
        background-color: #fff !important;
        border-radius: 2px !important;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 2px !important;
        background: linear-gradient(to right, #D8D8D8 3px, #FFF 4px) !important;
      }

      &:hover {
        border-color:#D4D4D4 !important;
      }

      &:focus {
        border-color:#FF8D06 !important;
        box-shadow: 0px 0px 0px 4px rgba(255, 141, 6, 0.30);
      }
    }

    .video-detail-new__button {
      margin-top: 12px;
    }
  }

  &__status {
    position: absolute;
    display: flex;
    width: calc(100% - 32px);
    padding: 8px;
    margin: 0 16px;
    align-items: center;
    gap: 8px;
    color:#631212;
    font-feature-settings: 'liga' off, 'clig' off;
    /* Typography/Small Text/1 - Regular */
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    border-radius: 4px;
    border: 1px solid #F2B5B5;
    background: #F8DADA;

    i {
      font-size: 20px;
    }
  }

  &__text {
    color: #878787;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;

    &--second {
      &:hover {
        background: #fff7da;
        cursor: pointer;
      }
    }
  }

  &__action {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    align-self: stretch;

    span {
      color: #878787;
      text-align: center;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }

    &--yellow {
      background: #fff6e5;
      padding: 16px;
      border-radius: 8px;
    }
  }

  &__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    gap: 16px;
    align-self: stretch;
  }

  &__video {
    position: relative;
    width: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    height: 358px;
    padding: 0 16px;

    .video-loading {
      width: 100%;
      height: 358px;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        color: #878787;
        font-size: 48px;
      }
    }
  }

  &__rating {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 16px;
    background: #FAFAFA;
    border-radius: 8px;
    margin: 0 16px 16px;

    @media only screen and (max-width: 1369px) {
      gap: 6px;
    }

    @media only screen and (max-width: 1280px) {
      gap: 4px;
      padding: 16px 8px;
    }

    @media screen and (max-width: 1160px) {
      flex-wrap: wrap;
    }

    .video-detail-new__score-icon {
      padding: 6px 8px;
      height: 32px;
      border: 1px solid #D4D4D4;
      background: var(--Background-Colors-White, #FFF);
      justify-content: space-between;
      align-items: center;
      transition: all 0.2s ease-in-out;
      flex: 1;

      @media only screen and (max-width: 1369px) {
        flex: auto;
      }

      span {
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px;
      }

      &:hover {
        background: #E5E5E5 !important;
      }

      &.active {
        border: 1px solid #FF8D06 !important;
      }
    }
  }

  &__transcript-rate {
    display: flex;
    height: 42px;
    padding: 8px 8px 8px 16px;
    margin-top: 16px !important;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    border-radius: 8px;
    background: #FFF8EC;
    margin-top: 24px;
    color: #333;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }

  &__arrows {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .arrow-btn {
    width: 26px;
    height: 26px;
    background: #ffffff;
    border: 1px solid #e4e4e4;
    border-radius: 4px;
    cursor: pointer;
    padding: 5px;

    &:disabled {
      background: #eeeeee !important;

      .arrow-icon {
        color: #c3c3c3;
      }
    }

    &.active {
      border: 1px solid #ff8d06 !important;
    }

    i {
      color: #ff8d06;
      font-size: 14px;
    }
  }

  .arrow-btn-radius {
    width: 36px;
    height: 36px;
    padding: 9px 8px;
    border: 1px solid #D4D4D4;
    border-radius: 40px;
    cursor: pointer;
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: center;

    &:disabled {
      background: #FAFAFA !important;
      border-color: #E5E5E5 !important;

      i {
        color: #C3C3C3 !important;
      }
      path {
        fill: #C3C3C3 !important;
      }
    }

    &.active {
      border: 1px solid #ff8d06 !important;
    }

    &:hover {
      background: #E5E5E5 !important;
    }

    i {
      color: #ff8d06;
      font-size: 14px;
      margin-right: 0;
    }
    path {
      fill: #ff8d06;
    }
  }

  &__button {
    display: flex;
    padding: 9px 16px;
    justify-content: center;
    align-items: center;
    border-radius: 114px;
    background: #ff8d06;
    color: #fff;
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    transition: all 0.2s ease-in-out;

    &:hover {
      background: #FF7415 !important;
    }
  }

  &__right {
    .sub-nav {
      .nav-item {
        width: calc(100% / 2) !important;
      }
    }

    .video-detail-new__header {
      padding: 16px 16px 0;
    }
  }

  &__left {
    .sub-nav {
      .nav-item {
        width: calc(100% / 3) !important;
      }
    }
  }

  .sub-nav {
    width: 100%;
    margin: 0 auto;
    height: 100%;
    max-height: 37px;
    overflow: hidden;
    padding: 0 16px;

    .nav {
      width: 100%;
    }

    .nav-item {
      position: relative;
      a {
        width: 100%;
        justify-content: center;
        color: #878787;
        font-family: Roboto;
        font-size: 14px !important;
        font-weight: 400 !important;
        line-height: 20px !important;
        padding: 0 12px 17px !important;

        &:after {
          height: 1px !important;
          background: #e5e5e5 !important;
          border-radius: 0;
        }

        &.active {
          color: #ff8d06 !important;
          font-weight: 700 !important;

          &:after {
            height: 3px !important;
            background: #ff8d06 !important;
            border-radius: 0 !important;
          }
        }

        i {
          margin-right: 2px;
        }
      }
    }
  }
}

.video-detail {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;

  ::v-deep ::-webkit-scrollbar {
    width: 3px !important;
  }

  ::v-deep ::-webkit-scrollbar-track {
    background-color: #FFF !important;
    border-radius: 10px;
  }

  ::v-deep ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #D8D8D8 !important;
  }

  @media only screen and (max-width: 1140px) {
    flex-direction: column;
    margin-top: 12px;
  }

  &__left {
    width: 41%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
    padding-bottom: 40px;

    @media screen and (max-width: 1140px) {
      width: 100%;
    }
  }

  &__right {
    width: 57%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    padding: 16px;
    gap: 16px;
    border-radius: 8px;
    border: 1px solid #E4E4E4;
    background: #FFF;

    @media screen and (max-width: 1140px) {
      width: 100%;
    }
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 16px;
    align-self: stretch;
  }

  &__title {
    color: #333;
    font-family: Roboto;
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;

    width: calc(100% - 24px);
  }

  &__subtitle {
    color: #333;
    font-family: Roboto;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    margin-bottom: 4px;
  }

  &__note-title {
    color: var(--Text-Colors-Secondary-Gray-Text, #878787);
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    padding: 0 8px;
  }

  &__arrows {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .arrow-btn {
    width: 26px;
    height: 26px;
    background: #ffffff;
    border: 1px solid #e4e4e4;
    border-radius: 4px;
    cursor: pointer;
    padding: 5px;

    &:disabled {
      background: #eeeeee !important;

      .arrow-icon {
        color: #c3c3c3;
      }
    }

    &.active {
      border: 1px solid #ff8d06 !important;
    }
  }

  .arrow-icon {
    color: #ff8d06;
    font-size: 14px;
  }

  .star-icon {
    color: #fff;
    font-size: 14px;
  }

  &__video {
    position: relative;
    width: 100%;
    max-width: 637px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    height: 358px;
  }

  &__rating {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
  }

  &__note {
    width: 100%;

    ::v-deep .form-control {
      padding: 8px !important;
      border: 1px solid #e5e5e5;
      background: #fff;
      font-weight: 400;
      color: #333 !important;
    }
  }

  &__action {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    align-self: stretch;

    span {
      color: #878787;
      text-align: center;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }

    &--yellow {
      background: #fff6e5;
      padding: 16px;
      border-radius: 8px;
    }
  }

  &__transcript {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
  }

  &__text {
    color: #878787;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;

    &--second {
      &:hover {
        background: #fff7da;
        cursor: pointer;
      }
    }
  }

  &__transcript-rate {
    display: flex;
    height: 42px;
    padding: 8px 16px;
    margin-top: 24px !important;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    border-radius: 8px;
    background: #fafafa;
    margin-top: 24px;
    color: #333;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }

  &__divider {
    width: 100%;
    height: 1px;
    background: #e5e5e5;
  }

  &__overal-rate {
    display: flex;
    padding: 16px 0px;
    margin: 0 12px 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-radius: 8px;
    background: #fafafa;
    min-height: 120px;
  }

  &__small-text {
    color: #878787;
    text-align: center;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }

  &__right {
    .video-detail__all-notes {
      max-height: 450px;
    }
  }

  &__all-notes {
    max-height: 300px;
    overflow-y: auto;
    position: relative;
    width: 100%;
    padding: 0 12px;

    -webkit-mask-image: linear-gradient(
      to bottom,
      transparent 0,
      black var(--top-mask-size, 0),
      black calc(100% - var(--bottom-mask-size, 0)),
      transparent 100%
    );
    mask-image: linear-gradient(
      to bottom,
      transparent 0,
      black var(--top-mask-size, 0),
      black calc(100% - var(--bottom-mask-size, 0)),
      transparent 100%
    );
    --top-mask-size: 0px;
    --bottom-mask-size: 0px;

    &.is-top-overflowing {
      --top-mask-size: 48px !important;
    }

    &.is-bottom-overflowing {
      --bottom-mask-size: 71px !important;
    }
  }

  &__transition-effect {
    position: sticky;
    left: 0;
    bottom: 0;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 100%);
    width: 100%;
    height: 71px;
  }

  &__tab-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    max-height: 680px;
    height: 100%;
    position: relative;

    .video-detail__action {
      margin: 0 auto;
      max-width: 260px;
      flex: 1;
      justify-content: center;
    }
  }

  &__summary {
    max-height: 320px;
    overflow-y: auto;
    position: relative;
    width: 100%;

    -webkit-mask-image: linear-gradient(
      to bottom,
      transparent 0,
      black var(--top-mask-size, 0),
      black calc(100% - var(--bottom-mask-size, 0)),
      transparent 100%
    );
    mask-image: linear-gradient(
      to bottom,
      transparent 0,
      black var(--top-mask-size, 0),
      black calc(100% - var(--bottom-mask-size, 0)),
      transparent 100%
    );
    --top-mask-size: 0px;
    --bottom-mask-size: 0px;

    &.is-top-overflowing {
      --top-mask-size: 48px !important;
    }

    &.is-bottom-overflowing {
      --bottom-mask-size: 71px !important;
    }
  }

  .b-rating {
    background: transparent !important;
    border: 0 !important;
    box-shadow: none !important;

    ::v-deep &.form-control {
      font-size: 32px !important;
    }
  }

  .small-rating {
    ::v-deep &.form-control {
      font-size: 12px !important;
    }
  }

  .stars {
    box-shadow: none;
    height: auto;
    min-height: auto;
  }

  .star-empty {
    color: #cecece !important;
  }
}

.overall {
  .sub-nav {
    width: calc(100% - 24px) !important;
    margin: 0 auto;
    height: 80px !important;
    overflow: hidden;

    .nav {
      width: 100%;
    }

    .nav-item {
      width: calc(100% / 3) !important;

      a {
        width: 100%;
        justify-content: center;
        color: #878787;
        font-family: Roboto;
        font-size: 14px !important;
        font-weight: 400 !important;
        line-height: 20px !important;
        padding: 0 12px 17px !important;

        &:after {
          height: 1px !important;
          background: #e5e5e5 !important;
          border-radius: 0;
        }

        &.active {
          color: #ff8d06 !important;
          font-weight: 700 !important;

          &:after {
            height: 3px !important;
            background: #ff8d06 !important;
            border-radius: 0 !important;
          }
        }
      }
    }
  }
}

.search-area {
  width: 100%;
  display: flex;
  align-self: center;
  position: relative;
  padding: 0 16px;

  &__icon {
    position: absolute;
    width: 1.0625rem;
    height: 1.0625rem;
    left: 28px;
    top: 10px;
  }

  &__input {
    width: 100%;
    padding-left: 36px !important;
    color: var(--Text-Colors-Secondary-Gray-Text, #878787);
    font-feature-settings: 'liga' off, 'clig' off;
    text-overflow: ellipsis;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    border: 1px solid #E5E5E5;
    box-shadow: none;

    &:hover {
      border-color: #D4D4D4 !important;
    }

    &:focus {
      border-color: #ff8d06 !important;
      box-shadow: 0px 0px 0px 4px rgba(255, 141, 6, 0.30);
    }
  }
}

.embed-responsive {
  position: relative;
  min-height: 300px;
  display: flex;
  align-items: center;
  // padding-top: 19%;
}

.embed-responsive-16by9 {
  &::before {
    padding-top: 0;
  }
}

.star {
  border: 1px solid #ff8d06;
  cursor: pointer;
  width: 24px;
  height: 24px;
}

.next-prev-btn {
  width: 36px !important;
  height: 36px !important;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border: 1px solid #ff8d06 !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  background: transparent !important;
}

.passive {
  color: #ff8d06;
  background-image: "url(/assets/global/star-passive.svg)";
}

.active {
  color: #ffc107;
  background-image: "url(/assets/global/star-active.svg)";
}

.embed-responsive-item {
  object-fit: cover;
  border-radius: 8px;
  border: 0 !important;
  box-shadow: none !important;

  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  margin-bottom: 8px;
}

.embed-responsive-item::full-screen {
  object-fit: contain;
}

::-moz-full-screen .embed-responsive-item {
  object-fit: contain;
}

.embed-responsive-item::-moz-full-screen {
  object-fit: contain;
}

.embed-responsive-item::-webkit-full-screen {
  object-fit: contain;
}

:not(:root):fullscreen {
  object-fit: contain !important;
}

.play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.video-detail-new__interview-counts {
  position: absolute;
  top: 24px;
  z-index: 1;
  width: calc(100% - 32px);
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  padding: 0px 24px;
  gap: 9px;

  .tab-switches{
    display: flex;
    padding: 1px 8px 1px 4px;
    justify-content: center;
    align-items: center;
    gap: 2px;
    border-radius: 512px;
    border: 1px solid #F2B5B5;
    background: #F8DADA;
    color: #631212;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;

    &:hover {
      background: #F0CDCD;
      border-color: #E09999;
      transition: all 0.2s ease-in-out;
      cursor: default;
    }
  }

 .connection-lost {
    display: flex;
    padding: 1px 8px 1px 4px;
    justify-content: center;
    align-items: center;
    gap: 2px;
    border-radius: 512px;
    border: 1px solid #F2B5B5;
    background: #F8DADA;
    color: #631212;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;

    &:hover {
      background: #F0CDCD;
      border-color: #E09999;
      transition: all 0.2s ease-in-out;
      cursor: default
    }
  }
}

.video-detail-new__video-controls {
  position: absolute;
  bottom: 24px;
  z-index: 1;
  width: calc(100% - 32px);
  padding: 0 24px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.step-btn {
  display: flex;
  width: 104px;
  padding: 9px 8px;
  justify-content: space-between;
  align-items: center;

  border-radius: 40px;
  border: 1px solid #FFF;
  background: rgba(255, 255, 255, 0.20);

  span {
    padding: 0 8px;
    color: #FFF;
    text-align: center;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.40);
  }

  &:disabled {
    background: rgba(255, 255, 255, 0.20) !important;
    border: 1px solid #C3C3C3;
    cursor: not-allowed !important;
    pointer-events: auto;

    span {
      color: #C3C3C3;
    }
  }
}

.rating-text {
  color: #878787;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.loader-gif {
  width: 40px;
  padding: 5px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: #ff8d06;
  --_m: conic-gradient(#0000 25%, #000), linear-gradient(#000 0 0) content-box;
  -webkit-mask: var(--_m);
  mask: var(--_m);
  -webkit-mask-composite: source-out;
  mask-composite: subtract;
  animation: l3 1s infinite linear;

  &--small {
    width: 14px;
    background: #fff;
  }
}
@keyframes l3 {
  to {
    transform: rotate(1turn);
  }
}

::v-deep {
  .accordion {
    width: 100%;
    overflow-x: hidden;

    .card {
      padding: 12px 0px;
      border: 0;
      border-bottom: 1px solid #e4e4e4;
      margin-bottom: 0 !important;

      &:last-child {
        border-bottom: 0;
      }

      .btn {
        padding: 0 !important;
        display: flex;
        justify-content: space-between;

        p {
          font-size: 14px;
          font-weight: 500;
          color: #353535;
        }
      }

      .collapsed > .when-closed {
        transform: rotate(0);
        transition: transform 0.35s;

        i {
          margin: 0;
        }
      }

      :not(.collapsed) > .when-closed {
        transform: rotate(180deg);
        transition: transform 0.35s;

        i {
          margin: 0;
        }
      }
    }
  }

  .tooltip-inner {
    display: flex;
    padding: 8px 8px 8px 12px;
    justify-content: center;
    align-items: center;
    gap: 2px;
    border-radius: 4px;
    border: 1px solid #e5e5e5 !important;
    background: #fff !important;
    box-shadow: 0px 2px 6px 0px rgba(176, 186, 197, 0.6);

    font-family: Roboto;
    color: #333;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }
}

::v-deep {
  .card-header {
    background-color: transparent;
    border-bottom: 0;
    padding: 0;
  }

  .card-header-pills {
    margin: 0;
  }

  .card-body {
    padding: 0;
    height: auto;
    max-height: 100% !important;
  }

  .card-block {
    padding: 16px 16px 0;
  }

  .card-text {
    color: #878787;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
}

#loading-analyze {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 3px solid #e6e6e6;
  border-radius: 50%;
  border-top-color: #ff8d06;
  animation: spin 1s cubic-bezier(0.46, 0.03, 0.52, 0.96) infinite;
  -webkit-animation: spin 1s cubic-bezier(0.46, 0.03, 0.52, 0.96) infinite;
}

@keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
  }
}

@-webkit-keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
  }
}

::v-deep .new-modal {
  .modal-dialog {
    max-width: 520px;
  }
  .modal-content {
    border-radius: 12px;
  }

  .modal-header {
    border-bottom: 0;
    padding: 12px 12px 0px 12px;

    i {
      font-size: 24px;
      color: #333333;
    }
  }

  .modal-body {
    border-bottom: 0;
    padding: 0px 24px 24px 24px;

    img {
      margin-bottom: 14px;
    }

    h2 {
      color: #353535;
      text-align: center;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Roboto;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 26px;
      margin-bottom: 8px;
    }

    p {
      color: #858585;
      text-align: center;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Roboto;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      margin-bottom: 24px;
    }
  }

  .border-button {
    display: flex;
    flex: 1;
    padding: 9px 16px;
    justify-content: center;
    align-items: center;
    border-radius: 114px;
    border: 1px solid #ff8d06;
    background: transparent !important;

    color: var(--main-colors-orange, #ff8d06);
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
    transition: all 0.2s ease-in-out;

    &:hover {
      background: #ff8d06 !important;
      color: #fff !important;
    }
  }

  .bg-button {
    display: flex;
    flex: 1;
    padding: 9px 16px;
    justify-content: center;
    align-items: center;
    border-radius: 114px;
    border: 1px solid #ff8d06;
    background: #ff8d06;

    color: #fff;
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
    transition: all 0.2s ease-in-out;

    &:hover {
      background: #FF7415 !important;
    }

    &.disabled {
      border-color: transparent;
    }
  }
}

::v-deep .form-control-feedback {
  padding: 8px !important;
  &.error {
    display: none;
  }
}

.feedback-form {
  ::v-deep .form-control {
    padding: 8px !important;
    border-radius: 4px !important;
    border: 1px solid #E5E5E5 !important;
  }
}

.feedback-length {
  color: #878787;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Roboto !important;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.video-detail__status {
  display: flex;
  width: calc(100% - 32px);
  padding: 8px;
  margin: 0 16px;
  align-items: center;
  gap: 8px;
  color:#631212;
  font-feature-settings: 'liga' off, 'clig' off;
  /* Typography/Small Text/1 - Regular */
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  border-radius: 4px;
  border: 1px solid #F2B5B5;
  background: #F8DADA;

  i {
    font-size: 20px;
  }
}

.blue-info {
  display: flex;
  padding: 8px;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid var(--Stroke-Colors-Light-Blue-Stroke, #B7E1F3);
  background: var(--Background-Colors-Light-Blue, #DBF0F9);
  color: var(--Text-Colors-Blue-Text, #114E67);
  margin: 12px 16px 0;

  span {
    flex: 1;
    font-feature-settings: 'liga' off, 'clig' off;
    /* Typography/Small Text/1 - Regular */
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }

  i {
    font-size: 20px
  }
}

.bs-tooltip-top {
  padding: 0 !important;
  top: -10px !important;

  ::v-deep .arrow {
    top: auto !important;
    bottom: -1px !important;

    &::before {
      border: 0 !important;
      background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="9" height="17" viewBox="0 0 9 17" fill="none"><path d="M9 0L9 17L1.53956 9.95403C0.703887 9.16478 0.703888 7.83522 1.53956 7.04597L9 0Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9 15.5L9 17L1.53956 9.95403C0.703887 9.16478 0.703888 7.83522 1.53956 7.04597L9 0L9 1.5L8 2.31994L2.22618 7.77299C1.80835 8.16761 1.80835 8.83239 2.22618 9.22701L8 14.6801L9 15.5Z" fill="%23E5E5E5"/></svg>') !important;
      width: 9px;
      height: 17px;
      transform: rotate(-90deg);
      bottom: 2px;
    }
  }
}
</style>
